import { getPage, post, put, del } from '@/utils/request'
import type { User } from '@/types'

export interface UserCreateForm {
  username: string
  email: string
  password: string
  nickname: string
  role: number
}

export interface UserUpdateForm {
  username?: string
  email?: string
  password?: string
  nickname?: string
  role?: number
  is_active?: boolean
}

export interface ProfileUpdateForm {
  nickname?: string
  email?: string
  avatar?: string
}

export interface PasswordChangeForm {
  old_password: string
  new_password: string
}

/** 获取用户列表（分页） */
export function listUsers(params: {
  page?: number
  page_size?: number
  keyword?: string
}) {
  return getPage<User>('/users', params)
}

/** 创建用户 */
export function createUser(data: UserCreateForm) {
  return post<User>('/users', data)
}

/** 更新用户 */
export function updateUser(id: number, data: UserUpdateForm) {
  return put<User>(`/users/${id}`, data)
}

/** 删除用户（软删除） */
export function deleteUser(id: number) {
  return del(`/users/${id}`)
}

/** 更新当前登录用户资料（个人中心） */
export function updateMyProfile(data: ProfileUpdateForm) {
  return put<User>('/users/me', data)
}

/** 修改当前登录用户密码（个人中心） */
export function changeMyPassword(data: PasswordChangeForm) {
  return put<null>('/users/me/password', data)
}

/** 上传头像图片，返回可直接访问的 URL（保存资料时随 avatar 字段提交） */
export function uploadAvatar(file: File) {
  const fd = new FormData()
  fd.append('file', file)
  return post<{ url: string }>('/uploads/image', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
